import React, { Fragment } from "react";
import { Segment, Grid } from "semantic-ui-react";
import { Link } from "react-router-dom";

const FibreOutage = props => {
  const { message } = props;

  return (
    <Segment inverted vertical>
      <Grid
        verticalAlign="middle"
        textAlign="center"
        className="mx-auto emergency-message"
      >
        <Grid.Row className="emergency-message__row">
          <Grid.Column>
            {message &&
              message.map((line, index) => (
                <Fragment key={index}>
                  {index === 0 ? (
                    <div className=" text-white emergency-message__title">
                      {line}
                    </div>
                  ) : (
                    <div className="mb-5 emergency-message__desc">{line}</div>
                  )}
                </Fragment>
              ))}

            <h2 className="no-decoration text-prime itc-mdbold mb-0 default-logo emergency-message__footer">
              <Link to={"/"}>
                Fibre
                <span className=" itc-std-md text-stream text-white">
                  Stream
                </span>
              </Link>
            </h2>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
};

export default FibreOutage;



// WEBPACK FOOTER //
// ./src/components/fibre-outage/FibreOutage.js